module.exports = __webpack_public_path__ + "static/media/sensable_85.55199948.jpg";